import { render, staticRenderFns } from "./FullNameInputForm.vue?vue&type=template&id=82974292&scoped=true&"
import script from "./FullNameInputForm.vue?vue&type=script&lang=js&"
export * from "./FullNameInputForm.vue?vue&type=script&lang=js&"
import style0 from "./FullNameInputForm.vue?vue&type=style&index=0&id=82974292&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82974292",
  null
  
)

export default component.exports